<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="直播列表" class="common-header">
                <mt-button slot="left" icon="back" @click="goBack"></mt-button>
                <mt-button slot="right" @click="onAdd">新增</mt-button>
            </mt-header>
        </div>
        <div>
            <div class="mt-5" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div v-if="liveApplyList && liveApplyList.length">
                    <div class="live-item mb-5" v-for="(item,index) in liveApplyList" :key="item.live_apply_id">
                        <div class="content">
                            <div class="live-header">
                                <div class="live-name">{{item.live_apply_name}}[直播ID:{{item.live_apply_id}}]</div>
                                <div class="live-state">
                                    <span v-if="item.live_apply_state==0">申请中</span>
                                    <span v-if="item.live_apply_state==1">已通过</span>
                                    <span v-if="item.live_apply_state==2">已拒绝</span>
                                </div>
                            </div>
                            <div v-if="item.goods_list" class="goods-list">
                                <div class="goods-item" v-for="(goods,i) in item.goods_list" :key="i">
                                    <img class="goods-image" :src="goods.goods_image" />
                                </div>
                            </div>
                            <div class="live-btn">
                                <mt-button class="edit-wrapper delete-wrapper" @click="onDelete(item.live_apply_id)" type="danger">删除</mt-button>
                                <mt-button v-if="ifComponent" class="edit-wrapper" @click="onUse(index,item.live_apply_id,item.live_apply_video)" type="default">应用</mt-button>
                                <mt-button v-if="!ifComponent && item.minipro_code" class="edit-wrapper" @click="openImage(item.minipro_code)" type="default">直播</mt-button>
                            </div>
                        </div>
                    </div>
                </div>
                <empty-record v-else />
            </div>
        </div>
        <div>
            <div v-if="isshow" popup-transition="popup-fade" class="my-popup common-popup-wrapper" style="z-index:1000">
                <div class="common-header-wrap">
                    <mt-header title="查看直播" class="common-header">
                        <mt-button slot="left" icon="back" @click="isshow=false"></mt-button>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                <live controls="controls" :src="showimage" :style="getBannerStyle"></live>
                </div>
            </div>
        </div>
        <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
            <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
        </mt-popup>
    </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getLiveApplyList,delLiveApply } from '../../../api/sellerLiveApply'

export default {
  name: 'CostList',
  props: {
    ifComponent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EmptyRecord
  },
  data () {
    return {
      showimage: '',
      isshow: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      liveApplyList: false // 记录列表
    }
  },
  computed: {
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height - 44
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }

  },
  methods: {
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    onUse (index,live_apply_id, live_name) {
        if(this.liveApplyList[index].live_apply_state!=1){
            Toast('只能应用已通过审核的直播')
            return
        }
      this.$emit('useLiveApply', live_apply_id, live_name)
    },
      onAdd(){
          if (this.ifComponent) {
              this.$emit('addLiveApply')
          } else {
              this.$router.push({ name: 'SellerLiveApplyForm', query: { action: 'add' } })
          }
      },
    goBack () {
      if (this.ifComponent) {
        this.$emit('closeLiveApplyList')
      } else {
        this.$router.go(-1)
      }
    },
    onDelete (live_apply_id) {
      MessageBox.confirm('您确定要删掉此直播吗？').then(action => {
        delLiveApply(live_apply_id).then(res => {
          this.reload()
        }).catch(error => {
          Toast(error.message)
        })
      })
    },

    getLiveApplyList (ispush) {
      Indicator.open()
      let params = this.params
      getLiveApplyList(params).then(res => {
        Indicator.close()

        if (ispush && this.liveApplyList) {
          this.liveApplyList = this.liveApplyList.concat(res.result.live_apply_list)
        } else {
          this.liveApplyList = res.result.live_apply_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.loading = false
      }).catch(error=>{
          Indicator.close()
          Toast(error.message)
      })
    },
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getLiveApplyList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.loading = false
      this.params.page = 0
      this.isMore = true
      this.liveApplyList = false
      this.loadMore()
    }
  }
}
</script>

<style scoped lang="scss">
.live-item{padding:.5rem;border-bottom:1px solid #eee;background:#fff;
    .live{width:8rem;height: 6rem;background: #000}
    .content{font-size:.7rem;padding-left:.5rem;
        .live-header{display: flex;
            .live-name{flex:1}
            .live-state{color:$primaryColor}
        }
        .goods-list{white-space: nowrap;width: 100%;overflow: hidden;overflow-x: auto;margin-top: .5rem;
            .goods-item{display: inline-block;margin-right: .5rem;width: 5rem;height: 5rem;
                .goods-image{width: 100%;height: 100%}
            }
        }
        .live-btn{padding-top:.5rem;overflow: hidden;
            .edit-wrapper{margin-left:1rem;float: right}
        }
    }
}
.my-popup {
    text-align: center;
    position: fixed;
    background: #fff;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transition: .2s ease-out;
    transition: .2s ease-out;}
</style>
